import React from "react";
import { useFormContext } from "react-hook-form";

interface Props {
    name: string;
    label?: string;
    options: Record<string, string>;
    isReadOnly?: boolean;
    initialOption?: string;
}

const SelectField = ({
    name,
    label,
    options,
    initialOption = "",
    isReadOnly = false,
}: Props) => {
    const { register } = useFormContext();

    return (
        <div key = {name} className={`flex flex-col gap-2`}>
            {label && <label className = {`dark:text-gray-100 mb-1`}>{label}</label>}
            {
                isReadOnly ?
                    <input
                        readOnly
                        type={"text"}
                        value={initialOption}
                        className = {`bg-gray-300 read-only:text-gray-800 dark:bg-brand-900 w-full p-2 rounded-md`}
                    />
                    :
                <select
                    className={`dark:bg-brand-900 cursor-pointer rounded-md p-2 border border-brand-900`}
                    {...register(name)}
                >
                    <option value="" disabled>Select an Option</option>
                    {
                        Object.entries(options).map(([ key, value ]) => (
                            <option key={key} value={key}>{value}</option>
                        ))
                    }
                </select>
            }
        </div>
    );
};

export default SelectField;